var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSidebarThingsNotCoveredIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1292_2450)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9999 0C23.2842 0 30 6.71558 30 14.9998C30 23.2842 23.2842 29.9998 14.9999 29.9998C6.71577 30 0 23.2842 0 14.9998C0 6.71558 6.71577 0 14.9999 0ZM19.9508 8.84424C20.2835 8.51147 20.8228 8.51147 21.1558 8.84424C21.4886 9.177 21.4886 9.71655 21.1558 10.0493L16.2047 14.9998L21.1556 19.9504C21.4883 20.2832 21.4883 20.8228 21.1556 21.1558C20.8228 21.4883 20.2835 21.4883 19.9505 21.1558L14.9999 16.2051L10.0492 21.1558C9.71672 21.4883 9.17693 21.4883 8.84417 21.1558C8.51141 20.823 8.51141 20.2834 8.84417 19.9504L13.7948 14.9998L8.84417 10.0493C8.51141 9.71655 8.51141 9.177 8.84417 8.84424C9.17693 8.51147 9.71647 8.51147 10.0492 8.84424L14.9999 13.7949L19.9508 8.84424Z",
    fill: "#009BA3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1292_2450"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarThingsNotCoveredIcon);
export default __webpack_public_path__ + "static/media/sidebar-things-not-covered-icon.8c91b662a2bed46874adf22c036c7737.svg";
export { ForwardRef as ReactComponent };